import {
  email,
  max,
  required,
  min,
  confirmed,
  numeric,
  regex,
  mimes
} from "vee-validate/dist/rules";
import { extend, setInteractionMode } from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} không được để trống"
});

extend("mimes", {
  ...mimes
});

extend("numeric", {
  ...numeric,
  message: "{_field_} phải là định dạng kiểu số"
});

extend("regex", {
  ...regex,
  message: "{_field_} không đúng hợp lệ"
});

extend("confirmed", {
  ...confirmed,
  message: "{_field_} không khớp"
});

extend("max", {
  ...max,
  message: "{_field_} không được lớn hơn {length} ký tự"
});

extend("min", {
  ...min,
  message: "{_field_} không được nhỏ hơn {length} ký tự"
});

extend("email", {
  ...email,
  message: "{_field_} không đúng định dạng email"
});

const phoneNumberRule = {
  message: "{_field_} phải là số điện thoại hợp lệ",
  validate(value, args) {
    // Custom regex for a phone number
    const MOBILEREG = /^(0|\+84|84)((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\d{3})(\d{3})$/;

    // Check for either of these to return true
    return MOBILEREG.test(value);
  }
};

extend("phoneNumber", phoneNumberRule);

const notIncludeSpecialCharacterRule = {
  message: "{_field_} không được bao gồm các ký tự đặc biệt",
  validate(value, args) {
    const VALIDREG = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀẾỂưăạảấầẩẫậắằẳẵặẹẻẽềềếểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷýỹ0-9\ \-]+$/;

    return VALIDREG.test(value);
  }
};

extend("notIncludeSpecialChar", notIncludeSpecialCharacterRule);

const validUrl = {
  message: "{_field_} phải là đường dẫn hợp lệ. Example: https://abc.com",
  validate(value, args) {
    const VALIDREG = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

    return VALIDREG.test(value);
  }
};

extend("validUrl", validUrl);

const strongPasswordRule = {
  message:
    "{_field_} phải có ít nhất 8 ký tự trong đó có 1 ký tự viết hoa, 1 ký tự chữ và 1 ký tự số.",
  validate(value, args) {
    // Custom regex for a phone number
    const PASSREG = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/;

    // Check for either of these to return true
    return PASSREG.test(value);
  }
};

extend("strongPassword", strongPasswordRule);
